import React, { useState } from "react";
import styled from 'styled-components';
import { COLOURS } from "../styles/Colours";
import { STYLES } from "../styles/Styles";
import FacebookIcon from '../images/facebook-f-brands.inline.svg';
import TwitterIcon from '../images/twitter-brands.inline.svg';
import InstagramIcon from '../images/instagram-brands.inline.svg';
import { baseUrl } from "../config";

interface Props {
  displayStyle?: 'text' | 'icons';
  linkTo?: 'share' | 'david';
  style?: React.CSSProperties;
}

export const ShareLinks = (props: Props) => {

  const {
    displayStyle = 'text',
    linkTo = 'share',
    style
  } = props;

  const [hasLinkBeenCopied, setHasLinkBeenCopied] = useState(false);

  const handleCopyLink = () => {
    const text = baseUrl;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      setHasLinkBeenCopied(true);
    } catch (err) {
    }

    document.body.removeChild(textArea);
  }

  const handleTwitterLink = () => {
    window.open('https://twitter.com/intent/tweet', 'name', 'width=600,height=400');
  }

  const handleFacebookLink = () => {
    window.open('https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fanunlikelyunion.canon.com.au%2F&amp;src=sdkpreparse', 'Name', 'width=600,height=400')
  }

  return (
    <ShareLinksContainer style={style}>
      {displayStyle === 'icons' &&
        <>
          <IconLink
            onClick={linkTo === 'share' ? handleTwitterLink : null}
            href={linkTo === 'share' ? null : 'https://twitter.com/pocockdavid'}
            target={linkTo === 'share' ? null : '_blank'}
            rel='noreferrer noopener'
            aria-label={linkTo === 'share' ? 'Share on Twitter' : 'David Pocock\'s Twitter'}
            >
            <TwitterIcon />
          </IconLink>
          {linkTo === 'david' &&
          <IconLink
            href='https://www.instagram.com/davidpocock/' target='_blank' rel='noreferrer noopener'
            >
            <InstagramIcon />
          </IconLink>
          }
          <IconLink
            onClick={linkTo === 'share' ? handleFacebookLink : null}
            href={linkTo === 'share' ? null : 'https://www.facebook.com/pocock.page/'}
            target={linkTo === 'share' ? null : '_blank'}
            rel='noreferrer noopener'
            aria-label={linkTo === 'share' ? 'Share on Facebook' : 'David Pocock\'s Facebook'}
            >
            <FacebookIcon />
          </IconLink>
        </>
      }
      {displayStyle === 'text' &&
        <>
          <ShareLabel>Share -</ShareLabel>
          <ShareLink
            onClick={() => window.open('https://twitter.com/intent/tweet', 'name', 'width=600,height=400')}
            aria-label='Share on Twitter'
            >Twitter</ShareLink>
          <ShareLink
            onClick={() => window.open('https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fanunlikelyunion.canon.com.au%2F&amp;src=sdkpreparse', 'Name', 'width=600,height=400')}
            aria-label='Share on Facebook'
          >
            Facebook
          </ShareLink>
          <ShareLink
              onClick={hasLinkBeenCopied ? null : handleCopyLink}
              aria-label='Copy the link to this website'
            >
            {hasLinkBeenCopied ? 'Link copied' : 'Copy link'}
          </ShareLink>
        </>
      }
    </ShareLinksContainer>
  )
}

export const ShareLinksContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShareLabel = styled.span`
  font-weight: 700;
  font-size: ${STYLES.textSize3};
  white-space: nowrap;
`;

const ShareLink = styled.a`
  margin-left: 1.5rem;
  color: ${COLOURS.blue};
  font-size: ${STYLES.textSize3};
  :hover {
    cursor: pointer;
  }
`;

const IconLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLOURS.charcoal};
  border-radius: 50%;
  width: 70px;
  height: 70px;
  padding: 0.5rem;
  margin: 0 auto;
  @media(min-width: ${STYLES.desktopSize}) {
    padding: 1rem;
    width: 100px;
    height: 100px;
  }
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
  svg {
    width: 50%;
    height: 50%;
    path {
      fill: ${COLOURS.white};
    }
  }
`;